import { PaymentError } from '@/app/errors/payment-error';
import { ValidationError } from '@/app/errors/validation-error';
import envService from '@/services/env.service';
import { datadogRum } from '@datadog/browser-rum';

function init() {
  datadogRum.init({
    applicationId: '812802a7-12b1-4f9f-974e-66715cc568be',
    clientToken: 'pubac39e99ef360561cb868bf79b243a4ed',
    site: 'us5.datadoghq.com',
    service: 'member-ui',
    env: (envService.getEnv().VITE_DEPLOYMENT_TARGET || 'local').toLowerCase(),
    version: envService.getEnv().VITE_VERSION || 'unknown',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [/https:\/\/.*\.catchbio\.com/],
    proxy: (options) => `${envService.getEnv().VITE_DATADOG_PROXY_URL}${options.path}?${options.parameters}`,
    beforeSend: (event, context) => {
      // Filter out user errors that are not system errors
      // Check if this is an error event (context will have error property for error events)
      if ('error' in context && context.error) {
        const error = context.error as any;
        // Filter out ValidationError instances - these are user input errors
        if (error?.name === 'ValidationError' || error instanceof ValidationError) {
          return false; // Don't send to Datadog
        }
        // Filter out PaymentError instances - these are expected payment failures
        if (error?.name === 'PaymentError' || error instanceof PaymentError) {
          return false; // Don't send to Datadog
        }
      }
      return true; // Send all other events
    },
  });
}

function setUser(userId: string) {
  try {
    datadogRum.setUser({
      id: userId,
    });
  } catch (error) {
    // Datadog not initialized (likely local environment)
  }
}

function clearUser() {
  try {
    datadogRum.clearUser();
  } catch (error) {
    // Datadog not initialized (likely local environment)
  }
}

export default { init, setUser, clearUser };
